(ns web3.routers.app
  (:require [web3.env :as env]
            [web3.lazy :as lazy]))

(def root
  {:paths
             ["/"
              (merge
                {"_/" :blank/public
                 "get-help-with/" :blank/public
                 "__" :blank/authed
                 "" :home

                 ;; NOTE: this route is shared in emails, so changing it could break in-progress transfers
                 ["transfer-accept/" :transfer-id] :property-transfer/accept.root

                 ["property/" :property-id]
                 {"" :home/property
                  ["/group/" :group-id] :group
                  "/files"
                  {"" :files
                   ["/" :collection] :files/collection}}
                 "ask" :ask

                 "authorize" :authorize
                 "logout" :logout
                 "signup-complete" :signup-complete
                 ;; in progress
                 "auth0-verify-email" :auth0-verify-email
                 ["youtube/" :youtube-id] :video/youtube
                 ["static" [#"(.*)" :url]] :static/html}
                (when env/devtools?
                  {"dev" {["/" :screen] :dev
                          "" :dev}}))]
   :handlers (lazy/loadable web3.routers.app-handlers/root)})

(def form-modal
  {:paths
   [""
    {
     ;; 1. "Flat" /add paths, with limited breadcrumbs.
     ;;    User enters the add flow based on entity type/category,
     ;;    and cannot go back.
     ;;
     ;;    Handlers use the :add/- namespace.

     "add"
                                                {"/file" {"" :add/file
                                                          ["/by-collection/" :collection] :add/file.collection} ;; note: :add/file.category has a breadcrumb to go "up",
                                                 ["/file-by-collection/" :collection] :add/file-by-collection ;;       :add/file-by-category has no breadcrumb.
                                                 "/item" {"" :add/asset
                                                          "/by-nameplate" :add/asset.nameplate
                                                          "/by-form" :add/asset.form}
                                                 "/group" :add/group
                                                 "/service-provider" :add/service-provider
                                                 "/property" {"" :add/property
                                                              "/address" :add/property.address
                                                              "/success" :add/property.create-successful}}

     "clarify"
                                                {["/item" :asset-id] :asset/clarify}

     ;; 2. "Deep" /add-anything paths, with full breadcrumbs.
     ;;    User enters the add flow at a particular entity type/category,
     ;;    but can always navigate back to any other part of the add flow.
     ;;
     ;;    Handlers use the :add-anything/- namespace.

     "add-anything"
                                                {"" :add-anything/start
                                                 "/item" :add-anything/asset
                                                 "/item-by-nameplate" :add-anything/asset-by-nameplate
                                                 "/item-by-form" :add-anything/asset-by-form
                                                 "/file" :add-anything/file
                                                 ["/file-by-collection/" :collection] :add-anything/file.collection
                                                 "/group" :add-anything/group
                                                 "/service-provider" :add-anything/service-provider
                                                 "/property" {"" :add-anything/property
                                                              "/address" :add-anything/property.address
                                                              "/success" :add-anything/property.create-successful}}

     ;; regular-expression paths can be added to any route
     #".*(add-end)" :add/end-confirm
     #".*(select-parent)" :modal/select-parent
     #".*(nameplate-locator)" :asset/nameplate-locator

     ["recall-respond/" :recall-id] :asset/recall-respond
     ["vimeo/" :vimeo-id] :media/vimeo
     ;; onboarding
     "welcome" {"" :welcome/start
                "/add-property" {"" :welcome/add.property
                                 "/address" :welcome/add.property.address}
                "/get-mobile" :welcome/get-mobile}

     ["property-transfer/create/" :property-id] {"/start" :property-transfer/create.start
                                                 "/complete" :property-transfer/create.complete}


     ["property-transfer/accept/" :transfer-id] {"/start" :property-transfer/accept.start
                                                 "/continue" :property-transfer/accept.continue}

     ["property-duplicate/" :property-id] :property/duplicate}]
   :handlers
   (lazy/loadable web3.routers.app-handlers/form-modal)})

(def content-modal
  {:paths
   [""
    {"details" {["/" :__typename "/" :id] :type/detail}
     "product-support" {["/by-uuid/" :id] :public-detail/by-uuid
                        ["/" [#".+" :brand] "/" [#".+" :model]] :public-detail/by-model}}]
   :handlers
   (lazy/loadable web3.routers.app-handlers/content-modal)})